"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icon_1 = require("../../elements/icon/icon");
var icon_type_1 = require("../../elements/icon/icon-type");
var alert_type_1 = require("./alert-type");
function getDefaultIcon(status) {
    var icon = (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.INFO });
    if (status === alert_type_1.AlertStatus.SUCCESS) {
        icon = (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.CHECK_MARK_CIRCLE_OUTLINED });
    }
    else if (status === alert_type_1.AlertStatus.ERROR) {
        icon = (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.ERROR_OUTLINED });
    }
    else if (status === alert_type_1.AlertStatus.WARNING) {
        icon = (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.WARNING_OUTLINED });
    }
    return icon;
}
exports.getDefaultIcon = getDefaultIcon;
